import ToolbarPopover from "../../../Navigation/ContextualToolbar/ToolbarPopover/ToolbarPopover";
import React, { useImperativeHandle, useRef } from "react";
import { appstr } from "@coreapp/utils/appstr";

const ConfirmationPopover = ({
  children,
  onClose = undefined,
  onSubmit,
  popoverProps = {},
  dataTestPrefix = "confirmation",
  openCtrlRef: userOpenCtrlRef,
  ...props
}) => {
  const openCtrlRef = useRef(null);

  useImperativeHandle(userOpenCtrlRef, () => ({
    ...openCtrlRef.current
  }));

  const closePopover = () => {
    openCtrlRef?.current?.setOpen(false);
    if (onClose) onClose();
  };

  const handleConfirm = () => {
    onSubmit();
    closePopover();
  };

  const handleCancel = () => {
    closePopover();
  };

  const overlayProps = {
    id: `${dataTestPrefix}-popover-overlay`,
    footerProps: {
      size: "large",
      buttonSize: "medium",
      footerActions: {
        cancelAction: handleCancel,
        cancelLabel: appstr("Cancel"),
        customAction: {
          onClick: handleConfirm,
          buttonProps: {
            modifier: "primary",
            dataTestId: `${dataTestPrefix}-confirm-btn`
          },
          label: props?.confirmLabel ?? appstr("Yes")
        }
      },
      ...props.otherFooterProps
    },
    headerProps: {
      size: "large",
      labelSize: "medium",
      modifier: "default",
      ...props.otherHeaderProps
    }
  };

  return (
    <ToolbarPopover
      className={"oc-confirmation-popover"}
      overlayProps={overlayProps}
      otherPopoverProps={{ openCtrlRef: openCtrlRef, ...popoverProps }}
      {...props}
    >
      {children}
    </ToolbarPopover>
  );
};

export default ConfirmationPopover;
